import {types, getRoot} from 'mobx-state-tree';
import axios from "axios";

export default types.model("Reports", {}).views(self => ({

    get navigation() {
        return getRoot(self).navigation;
    }

})).actions(self => {


    return {

        async getOrderDocumentUrl(type, orderGuid, cancelToken) {
            const currentCustomerId = self.navigation.getCustomerId();
            const siteId = self.navigation.SiteId;
            const res = await self.request("/Umbraco/Api/MyPages/GetOrderDocumentContent", {Type: type, OrderGuid: orderGuid, CustomerId: currentCustomerId, SiteId: siteId},
                {
                    cancelToken: cancelToken
                });
            return res;
        },

        async getOrderCopies(page = 1, cancelToken) {
            const res = await self.request("/Umbraco/Api/MyPages/OrderCopies", {
                    Page: page, CustomerId: self.navigation.getCustomerId(),
                    CultureCode: self.navigation.CultureCode
                },
                {
                    cancelToken: cancelToken
                });
            return res;
        },

        async getOrderCopy(orderGuid, cancelToken) {
            const res = await self.request("/Umbraco/Api/MyPages/OrderCopy", {
                    OrderGuid: orderGuid,
                    CustomerId: self.navigation.getCustomerId(),
                    CultureCode: self.navigation.CultureCode
                },
                {
                    cancelToken: cancelToken
                });
            return res;
        },


        async getOrderHistory(page = 1, cancelToken) {
            const currentCustomerId = self.navigation.getCustomerId();
            const siteId = self.navigation.SiteId;
            const res = await self.request("/Umbraco/Api/MyPages/OrderHistory", currentCustomerId ? {CustomerId: currentCustomerId, SiteId: siteId, Page: page} : {},
                {
                    cancelToken: cancelToken
                });
            return res;
        },


        async getInvoiceHistory(page = 1, cancelToken) {
            const currentCustomerId = self.navigation.getCustomerId();
            const siteId = self.navigation.SiteId;
            const res = await self.request("/Umbraco/Api/MyPages/InvoiceHistory", currentCustomerId ? {CustomerId: currentCustomerId, SiteId: siteId, Page: page} : {},
                {
                    cancelToken: cancelToken
                });
            return res;
        },


        async downloadFile(url, parameters) {
            await self.request(url, {...parameters, responseType: "blob"})
                .then((response) => {

                        let blob = new Blob([response.data], {type: response.headers['content-type']});
                        let tempUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        const contentDisposition = response.headers['content-disposition'];
                        let fileName = 'unknown';
                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
                            if (fileNameMatch.length === 2)
                                fileName = fileNameMatch[1];
                        }
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(tempUrl);
                    },
                    error => {
                    });
        },


        async request(path, query = {}, options) {
            const res = await axios.post(`${path}`, query, options);
            return res.data;
        },
    }
});